<template>
  <div class="sw-modal">
    <div v-click-outside="cancel" class="sw-modal-content sw-modal-content--wide card update-credit-card" v-on:click.stop>
      <div class="card-header">
        <h4>Update Credit Card</h4>
      </div>
      <div class="card-body">
        <div v-if="loading" class="text-center">
          Loading
          <spinner></spinner>
        </div>
        <form v-bind:action="successRedirect" class="paymentWidgets" data-brands="VISA MASTER"></form>
      </div>
      <div class="text-center">
        <button v-on:click="cancel" class="btn btn-secondary">Cancel</button>
      </div>
    </div>
  </div>
</template>

<script>
    import { store } from '@/store.js'
    import Spinner from "../Spinner";

    export default {
        name: "UpdateCreditCard",
        components: {Spinner},
        data: function() {
            return {
                loading: true,
                checkoutId: null
            }
        },
        computed: {
            successRedirect: function() {
                return this.getHostBaseURL + '/credit-card-updated?companyReference=' + store.host.company.reference;
            },
            getHostBaseURL: function() {
                return process.env.VUE_APP_HOST_BASE_URL;
            },
            getPeachPaymentsBaseURL: function() {
                return process.env.VUE_APP_PEACH_PAYMENTS_BASE_URL;
            }
        },
        methods: {
            prepareTokenization: function () {
                this.$http.post('/guest-management/v1/companies/' + store.host.company.reference + '/billing/prepare-tokenization'
                ).then(response => {
                    console.log(response);
                    this.checkoutId = response.data;
                    let peachPaymentsScript = document.createElement('script');
                    peachPaymentsScript.src = this.getPeachPaymentsBaseURL + '/v1/paymentWidgets.js?checkoutId=' + this.checkoutId + '/registration';
                    document.head.appendChild(peachPaymentsScript);
                    this.loading = false;
                }).catch(error => {
                    if (error.response && error.response.data.message) {
                        this.error = error.response.data.message;
                    } else {
                        this.error = "There was a problem loading the credit card capture form. Please try again.";
                    }
                });
            },
            cancel: function() {
                this.$root.$emit('finished-updating-credit-card');
            },
        },
        mounted() {
            this.prepareTokenization();
        },
    }
</script>

<style lang="scss" scoped>
  @import "../../styles/components/modal";
  @import "../../styles/components/update_credit_card";
</style>